
import { WeblinkFault } from '../weblink-fault/weblink-fault';
import { Status } from '../../../core/status/status';
import { SafeUrl } from '@angular/platform-browser';
import {Activity} from "../../../core/activity/activity";


export enum FaultState {
  canEdit,
  cannotEdit,
  mustUpload,
  uploadingActivity,
  uploadingAttachment,
  uploadErrorActivity,
  uploadErrorAttachment,
  synced
}

export class EditableFault extends WeblinkFault {

  isSelected = false;
  newStatus?: Status = null;
  closedActivity?: Activity = null;
  newText: string = null;
  newFiles?: File[] = [];
  newFormData?: FormData = null;
  filter = false;
  search: string;
  faultState: FaultState;
  currentAttachmentId: number;

  //attachmentUrl: SafeUrl;
  // mustSyncActivity = false;
  // syncActivityError = false;
  // mustSyncAttachment = false;
  // syncAttachmentError = false;

  public getFieldValue(fieldName: string): string {
    return 'test';
  }





}
